import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@one-thd/sui-atomic-components';

export const AddToLink = ({ onClick, disabled, text }) => {
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <Link
      disabled={disabled}
      component="button"
      color={!disabled ? 'primary' : 'inactive'}
      onClick={onClick}
      data-testid={`${text?.toLowerCase()}-add-to-link`}
    >
      {text}
    </Link>
  );
};

AddToLink.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  text: PropTypes.string
};

AddToLink.defaultProps = {
  onClick: () => {},
  disabled: false,
  text: ''
};